module.exports = __webpack_public_path__ + "17a217bbfa6d0db121817a46f6069c50.svg";